import * as React from "react";
// import "../styles/pages/sale.scss"
import styles from "../styles/pages/sale.module.scss";
import { withRouter } from "next/router";
import {
  DeliveryOfferKey,
  IProduct,
  ISale,
  ShippingPolicyByDeliveryOffer,
} from "../types/sale";
import { transformPrice as transformPriceWithCurrency } from "../api/currency";
import {
  formatPublicHome,
  formatNextHome,
  formatBasic,
  transformImage,
} from "../utils";
import MetaHeader from "../components/meta-header/meta-header";
import { trackPage } from "../api";
import {
  ProductCarouselComponent,
  ModalImageComponent,
} from "../components/external";
import LazyProductImage from "../components/lazy-product-image/lazy-product-image";
import { withTranslation } from "next-i18next";
import nextI18NextConfig from "../next-i18next.config.js";
const transformModele = (key: number) => {
  if (key === 0) {
    return "Féminin";
  } else if (key === 1) {
    return "Masculin";
  }
  return "Unisexe";
};
import { canonical } from "../config";
import { getLang } from "../utils/lang";
import { HeaderTesterComponent } from "../new-components/header-test/HeaderTest";
import FooterTestComponent from "../new-components/footer-test/FooterTest";
import { FAQComponent } from "../components/faq/faq";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { catalogApi } from "../api/catalog";
class ProductScreen extends React.Component<
  {
    router: any;
    sale: ISale;
    history: Array<{ path: string; value: string }>;
    product?: IProduct;
    i18n?: any;
    t?: any;
  },
  {}
> {
  get getTitle() {
    if (this.props.product && this.props.product.brand_name) {
      return `${this.props.product.brand_name} - ${
        this.props.product.subtitle
      } | ${this.getTrad("sale_ongoing")}`;
    }
    return ``;
  }

  get getDescription() {
    if (this.props.sale.sale_ended) {
      return `${this.props.product.brand_name} - ${
        this.props.product.subtitle
      } ${this.getTrad("discover")}. ${this.getTrad("sale_delivery")}`;
    } else if (this.props.sale.sale_started) {
      return `${this.props.product.brand_name} - ${
        this.props.product.subtitle
      } ${this.getTrad("discover")} ${this.getTrad("basic")} ${formatPublicHome(
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}. ${this.getTrad("sale_delivery")}`;
    }
    return `${this.props.product.brand_name} - ${
      this.props.product.subtitle
    } ${this.getTrad("discover")} ${this.getTrad("basic")} ${formatNextHome(
      this.props.sale.start_at,
      this.props.sale.end_at,
      getLang(this.props.i18n),
      this.props.sale.store
    )}. ${this.getTrad("sale_delivery")}`;
  }

  get getMainImage() {
    if (
      this.props.product &&
      Array.isArray(this.props.product.images) &&
      this.props.product.images[0]
    ) {
      return transformImage(this.props.product.images[0].url, "750");
      // return `https://img.appchoose.io/unsafe/630x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
      //   this.props.product.images[0].dark_color ? "white" : "black"
      // }.png,158,272,50)/prod/${
      //   this.props.product.images[0].url.split("/prod/")[1]
      // }`;
    }
  }

  get isAvailable() {
    if (this.props.sale) {
      return (
        !this.props.sale.sale_ended &&
        this.props.sale.sale_started &&
        !this.props.product.tester
      );
    }
    return undefined;
  }

  get getAppleMeta() {
    if (this.props.product) {
      if (!this.props.sale?.single_offer && this.props.sale?.url) {
        return `chooseapp://sales/${encodeURIComponent(this.props.sale.url)}`;
      }
      return `chooseapp://product/${encodeURIComponent(
        this.props.product.url
      )}`;
    }
  }

  get getAvailability() {
    if (this.props.sale) {
      if (this.props.sale.sale_ended) {
        return "https://schema.org/Discontinued";
      } else if (this.props.sale.sale_started) {
        return this.props.product.stock !== 0
          ? "http://schema.org/InStock"
          : "http://schema.org/OutOfStock";
      }
    }
    return "https://schema.org/PreOrder";
  }

  get getGender() {
    if (this.props.product) {
      if (this.props.product.gender === 0) {
        return "female";
      } else if (this.props.product.gender === 1) {
        return "male";
      }
      return "unisex";
    }
    return "unisex";
  }

  get getText() {
    if (this.props.sale.sale_ended) {
      return this.getTrad("sale_ended");
    } else if (this.props.sale.sale_started) {
      return `${this.getTrad("sale_ongoing")} ${formatPublicHome(
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}`;
    }
    return `${this.getTrad("sale_next")} ${formatNextHome(
      this.props.sale.start_at,
      this.props.sale.end_at,
      getLang(this.props.i18n),
      this.props.sale.store
    )}`;
  }

  public get renderFaq() {
    if (this.props.product.faq) {
      return (
        <>
          <hr className={styles.sale_hr + " " + styles.hrlight} />
          <h3>{this.getTrad("how_it_works")}</h3>
          <FAQComponent faq={this.props.product.faq} />
        </>
      );
    }
    return null;
  }

  get renderPrices() {
    if (this.displayDifferentPrices()) {
      return (
        <div>
          <p className="col-2 col-md-12">{this.props.t("price")}</p>
          <p
            className="col-6 col-md-12"
            dangerouslySetInnerHTML={{
              __html: this.props.product.variants
                .map((variant) => {
                  if (variant.options[variant.options.length - 1]) {
                    return `${variant.options
                      .map((option) => option.value)
                      .join(", ")} : ${transformPriceWithCurrency(
                      variant.formatted_price,
                      this.props.i18n.language || "fr",
                      this.props.product.currency
                    )}`;
                  }
                  return "";
                })
                .join("<br/>"),
            }}
          />
        </div>
      );
    }
    return null;
  }

  displayDifferentPrices() {
    const min = Math.min(
      ...this.props.product.variants.map((c) => c.formatted_price)
    );
    const max = Math.max(
      ...this.props.product.variants.map((c) => c.formatted_price)
    );
    return this.props.product.variants.length > 1 && min !== max;
  }

  renderDeliveryDelays(min: number, max: number) {
    if (this.props.product.type === "coupon") {
      return null;
    }

    if (min === max) {
      return (
        <p>
          {this.props.t("deliverydelays")}
          <span>
            {min} {this.props.t("day")}
          </span>
        </p>
      );
    }
    return (
      <p>
        {this.props.t("deliverydelays")}
        <span>
          {" "}
          {min} - {max} {this.props.t("day")}
        </span>
      </p>
    );
  }

  get ecoPart() {
    if (this.props.product.eee_price) {
      return (
        <p className={styles.price_normal_eee}>
          {this.props.t("ecopart")}{" "}
          <b>
            {transformPriceWithCurrency(
              this.props.product.eee_price,
              this.props.i18n.language,
              this.props.product.currency
            )}
          </b>
        </p>
      );
    }
    const ecoparts = this.props.product.variants
      .map((c) => c.eee_price)
      .filter((c) => c > 0);

    if (ecoparts.length) {
      const max = Math.max(...ecoparts);
      const min = Math.min(...ecoparts);
      return (
        <p className={styles.price_normal_eee}>
          {this.props.t("ecopart")}{" "}
          <b>
            {max === min
              ? transformPriceWithCurrency(
                  max,
                  this.props.i18n.language,
                  this.props.product.currency
                )
              : `${transformPriceWithCurrency(
                  min,
                  this.props.i18n.language,
                  this.props.product.currency
                )} - ${transformPriceWithCurrency(
                  max,
                  this.props.i18n.language,
                  this.props.product.currency
                )}`}
          </b>
        </p>
      );
    }
    return null;
  }

  get renderCashback() {
    if (!this.props.product.cashback_policy) {
      return;
    }
    return (
      <>
        <div className={styles.sizes}>
          <h4>
            <b>{this.props.t("cashback")}</b>
          </h4>
          {this.props.product.cashback_policy.thresholds.map((c) => {
            return (
              <p key={c.threshold}>
                {transformPriceWithCurrency(
                  c.cashback_amount,
                  this.props.i18n.language,
                  this.props.product.currency
                )}{" "}
                {this.props.t("cashback_free")}{" "}
                {transformPriceWithCurrency(
                  c.threshold,
                  this.props.i18n.language,
                  this.props.product.currency
                )}{" "}
                {this.props.t("cashback_purchase")}
              </p>
            );
          })}
        </div>
      </>
    );
  }

  private getDeliveryOfferLabel(type: DeliveryOfferKey): string {
    switch (type) {
      case "StandardHomeDelivery":
        return this.props.t("shipping.StandardHomeDelivery");
      case "StandardPickupDelivery":
        return this.props.t("shipping.StandardPickupDelivery");
      case "ExpressHomeDelivery":
        return this.props.t("shipping.ExpressHomeDelivery");
      default:
        return type;
    }
  }

  /**
   * The minimum order amount shared by every delivery offer, `null` as soon as
   * they differ. When they all share the same one, it is displayed on a single
   * line instead of on each delivery offer.
   */
  private getCommonFreeShippingOverOrderAmount(
    policiesByDeliveryOffer: ShippingPolicyByDeliveryOffer[]
  ): number | null {
    const [firstPolicy] = policiesByDeliveryOffer;
    const firstAmount = firstPolicy?.free_shipping_over_order_amount ?? null;

    return firstAmount &&
      policiesByDeliveryOffer.every(
        (policy) => policy.free_shipping_over_order_amount === firstAmount
      )
      ? firstAmount
      : null;
  }

  /**
   * Franco de port, displayed on a single line when every delivery offer shares
   * the same minimum order amount, on one line per delivery offer otherwise.
   */
  get renderFreeShippingOverOrderAmount() {
    if (!this.props.product.shipping_policy || !this.props.product.delivery) {
      return null;
    }

    const policiesByDeliveryOffer =
      this.props.product.shipping_policy.policies_by_delivery_offer ?? [];

    if (!policiesByDeliveryOffer.length) {
      return;
    }

    const commonFreeShippingOverOrderAmount =
      this.getCommonFreeShippingOverOrderAmount(policiesByDeliveryOffer);

    if (commonFreeShippingOverOrderAmount) {
      return this.renderFreeShippingOverOrderAmountLine(
        commonFreeShippingOverOrderAmount
      );
    }

    return policiesByDeliveryOffer.map((policy) =>
      this.renderFreeShippingOverOrderAmountLine(
        policy.free_shipping_over_order_amount,
        this.getDeliveryOfferLabel(policy.delivery_offer_key),
        policy.delivery_offer_key
      )
    );
  }

  private renderFreeShippingOverOrderAmountLine(
    freeShippingOverOrderAmount: number | null,
    deliveryOfferLabel?: string,
    key?: string
  ) {
    if (!freeShippingOverOrderAmount) {
      return null;
    }

    return (
      <p key={key}>
        {deliveryOfferLabel}
        {this.props.t("francoport")}
        <b>
          {" "}
          {transformPriceWithCurrency(
            freeShippingOverOrderAmount,
            this.props.i18n.language,
            this.props.product.currency
          )}
        </b>
      </p>
    );
  }

  get renderShipping() {
    if (this.props.product.type === "coupon") {
      return null;
    }
    const max = Math.max(
      ...this.props.product.variants.map((c) => c.delivery_delays)
    );
    const min = Math.min(
      ...this.props.product.variants.map((c) => c.delivery_delays)
    );
    return (
      <>
        <div className={styles.sizes}>
          <h4>
            <b>{this.props.t("shipping")}</b>
          </h4>
          <p>
            {" "}
            {transformPriceWithCurrency(
              this.props.product.delivery,
              this.props.i18n.language,
              this.props.product.currency
            )}
            <i style={{ marginLeft: 8 }}>
              {this.props.product.delivery_offered_until
                ? this.props.t("offereduntil") +
                  formatDate(
                    this.props.product.delivery_offered_until,
                    this.props.i18n.language
                  )
                : ""}
            </i>
          </p>

          <p>
            {this.props.t("deliverby")}
            {this.props.product.deliver_by_choose
              ? "Choose"
              : this.props.product.brand_name}
          </p>

          {this.renderFreeShippingOverOrderAmount}
          {this.renderDeliveryDelays(min, max)}
        </div>
      </>
    );
  }

  get renderGender() {
    if (typeof this.props.product.gender === "number") {
      return (
        <div>
          <p className="col-2 col-md-12">Modèle</p>
          <p className="col-6 col-md-12">
            {transformModele(this.props.product.gender)}
          </p>
        </div>
      );
    }
    return null;
  }
  get renderDetails() {
    if (Array.isArray(this.props.product.details)) {
      return this.props.product.details.map((c) => {
        if (c.key === "Modèle") {
          return null;
        }
        return (
          <div key={c.key}>
            <p className="col-2 col-md-12">{c.key}</p>
            <p className="col-6 col-md-12">{c.value}</p>
          </div>
        );
      });
    }
  }

  public get renderOptions() {
    if (this.props.product.options) {
      return this.props.product.options
        .sort((a, b) => (a.position > b.position ? 1 : -1))
        .map((c) => {
          return this.renderSizes(c);
        });
    }
    return null;
  }

  public state: {
    selectedImageId: number;
    displayModal: boolean;
  } = {
    selectedImageId: 0,
    displayModal: false,
  };

  public getTrad = (str: string) => {
    return this.props.t(str);
  };

  // tslint:disable-next-line:cognitive-complexity
  public async componentDidMount() {
    if (this.props.product) {
      trackPage("Product", { id: this.props.product.id, tester: true });
    }
  }

  public onModalClick = () => {
    this.setState({ displayModal: !this.state.displayModal });
  };

  public onImageSelect = (selectedImageId: number) => {
    this.setState({ selectedImageId });
  };

  public onClick = () => {
    const id =
      this.props.router.query.id &&
      this.props.router.query.id.indexOf("@v=") > -1
        ? this.props.router.query.id.split("@v=")[1]
        : undefined;
    this.props.router.push(
      "/testing/" +
        this.props.product.sale_id +
        "@v=" +
        id +
        "?name=" +
        this.props.product.brand_name
    );
  };

  public renderSizes(option: { name: string; values: string[] }) {
    return (
      <div key={option.name} className={styles.sizes}>
        <h4>
          <b>
            {option.values.length} {option.name}
            {option.values.length > 1 ? "s" : ""}
          </b>{" "}
          {this.props.t("available")}
          {option.values.length > 1 ? "s" : ""} :
        </h4>
        <ul>
          {option.values.map((size) => (
            <li key={size}>
              <b>{size}</b>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  // public get renderVariants() {
  //   if (this.props.product.variants) {
  //     return this.props.product.variants
  //       .map((c) => {
  //         // return this.renderSizes(c);
  //         const option = c.options.map((o)=>o.value).join('-')
  //         const image = c.images.length ? this.props.product.images.find((i)=>i.key === c.images[0])?.url : ""
  //         return <div>
  //           <img src={transformImage(image,"80x80")} />
  //           <p>{option}</p>
  //           <p className={styles.price_formatted}>
  //                 {transformPriceWithCurrency(
  //                   c.formatted_price as number,
  //                   this.props.i18n.language || "fr",
  //                   this.props.product.currency
  //                 )}
  //                 {/* {this.props.product.formatted_price} */}
  //               </p>
  //         </div>
  //       });
  //   }
  //   return null;
  // }

  public displayDetails() {
    return (
      Array.isArray(this.props.product.details) || this.displayDifferentPrices()
    );
  }

  // tslint:disable-next-line:cognitive-complexity
  public render() {
    return (
      <div className={styles.sale + " " + styles.tester}>
        <MetaHeader
          canonical={canonical + "product/" + this.props.product.url}
          keywords={
            this.props.product.subtitle + "," + this.props.product.brand_name
          }
          appleArguments={this.getAppleMeta}
          pageTitle={this.getTitle}
          isSquare={true}
          description={this.getDescription}
          title={this.getTitle}
          image={this.getMainImage}
          noIndex={true}
        />
        <HeaderTesterComponent
          link={this.props.history[0].path}
          name={this.props.product.title || this.props.product.brand_name}
          onClick={this.onClick}
        />
        <div className={`container align-items-center ${styles.margin}`}>
          <div className={styles.breadcrump}>
            <a href={this.props.history[0].path}>
              {this.props.history[0].value}
            </a>
            <span>/</span>
            <a href={this.props.history[1].path}>
              {this.props.history[1].value}
            </a>
          </div>
          <div className={`row ${styles.sale_data} ${styles.product_data}`}>
            {!this.state.displayModal ? null : (
              <ModalImageComponent
                images={this.props.product.images.map((c) => c.url)}
                focusOn={this.state.selectedImageId}
                onClose={this.onModalClick}
              />
            )}
            <ProductCarouselComponent
              images={this.props.product.images}
              onClickModal={this.onModalClick}
              className={styles.carousel}
              onSelect={this.onImageSelect}
              idxSelected={this.state.selectedImageId}
            />

            <div className={`col-sm-0 col-1 col-md-2 ${styles.separation}`} />
            <div className={`col-4 col-md-8 col-sm-12 ${styles.sale_info}`}>
              <h1 className={styles.title_brand}>
                {this.props.product.title || this.props.product.brand_name}
              </h1>
              <p className={styles.title_product}>
                {this.props.product.subtitle}
              </p>
              <div className={styles.prices}>
                <p className={styles.price_formatted}>
                  {transformPriceWithCurrency(
                    this.props.product.formatted_price as number,
                    this.props.i18n.language || "fr",
                    this.props.product.currency
                  )}
                  {/* {this.props.product.formatted_price} */}
                </p>
                {this.props.product.price !==
                this.props.product.formatted_price ? (
                  <p className={styles.price_normal}>
                    {transformPriceWithCurrency(
                      this.props.product.price,
                      this.props.i18n.language || "fr",
                      this.props.product.currency
                    )}
                  </p>
                ) : null}
                {this.ecoPart}
              </div>

              <button>{this.props.t("addtocart")}</button>
              {this.renderOptions}

              {/* {this.renderVariants} */}
              {this.renderShipping}
              {this.renderCashback}
            </div>
          </div>
          <div className="row">
            <div className={`col-sm-0 col-2 col-md-2 ${styles.separation}`} />
            <div className="col-8 col-md-8 col-sm-12">
              <hr className={styles.sale_hr} />
              <h3>Description</h3>
              {this.props.product.badges ? (
                <div className={styles.badges}>
                  {this.props.product.badges.map((badge) => {
                    return (
                      <div className={styles.badge} key={badge.text}>
                        <LazyProductImage
                          height="16"
                          width="16"
                          disableWebp={true}
                          src={badge.image}
                          alt={badge.text}
                        />
                        <p>{this.props.t(badge.code)}</p>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              <p className={styles.description}>
                {this.props.product.description}
              </p>

              {this.displayDetails() ? (
                <div className={styles.details}>
                  <hr className={styles.sale_hr} />
                  <h3>{this.props.t("details")}</h3>
                  {this.renderPrices}
                  {/* {this.renderGender} */}

                  {this.renderDetails}
                </div>
              ) : null}
              {this.props.product.type === "coupon" ? this.renderFaq : null}
              {this.props.product.type === "coupon" ? (
                <div className="cgu">
                  <hr className={styles.sale_hr + " " + styles.hrlight} />
                  <h3>{this.getTrad("how_it_works")}</h3>
                  <p className={styles.cguText}>
                    <img
                      alt="info"
                      src="https://public.choose.app/website/new/images/Info.svg"
                      height="16"
                      width="16"
                    />
                    {this.getTrad("valid_until")}
                    <b>
                      {formatBasic(
                        this.props.product.coupon_expire_at,
                        getLang(this.props.i18n),
                        this.props.sale.store
                      )}
                    </b>
                  </p>
                  {Array.isArray(this.props.product.cgu) ? (
                    <ul className={styles.cgu}>
                      {this.props.product.cgu.slice(0, 3).map((cgu) => (
                        <li key={cgu}>{cgu}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <FooterTestComponent url={this.props.product.sale_id} />
      </div>
    );
  }
}

export const getServerSideProps = async (props) => {
  const tmp = {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "keys", "sale"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query?.store || "fr",
    },
  } as any;
  try {
    // let product = {} as any;
    // let sale = {} as ISale;
    const id = props.query.id;
    let v = props.query.v;
    let variant = props.query.variant;
    let collapse_key = props.query.collapse_key ?? "";
    if (
      typeof v === "string" &&
      v &&
      v.length === "e8c0df85ef6d425a876b".length &&
      !variant
    ) {
      variant = v;
      v = undefined;
    }
    // const id = props.query.id ? props.query.id.split("@v=")[0] : undefined;
    const product = await catalogApi.getProductTester(
      id,
      v,
      decodeURIComponent(collapse_key),
      props.query.store
    );
    // console.log(product)
    const history = [
      {
        path: "/tester/" + product.sale_id + "@v=" + v,
        value: product.brand_name,
      },
      {
        path: "/product/" + encodeURIComponent(product.url || id) + "@v=" + v,
        value: product.subtitle,
      },
    ];

    tmp.props.history = history;
    tmp.props.v = v;
    tmp.props.url = id;
    tmp.props.product = product;
    tmp.props.sale = {};
    tmp.props.userAgent = props.query ? props.query.ua : {};
    // }

    // } else {
    //     return {
    //         redirect: {
    //             destination: '/error',
    //             permanent: false,
    //         },
    //     }
    // }
  } catch (error) {
    tmp.props.error = error;
    tmp.props.sale = {};
    tmp.props.isServerRendered = !!props.req;
    tmp.props.userAgent = props.query ? props.query.ua : {};
  }
  return tmp;
};

export default withTranslation("sale")(withRouter(ProductScreen));

const formatDate = (date: string, lang: any) => {
  try {
    const d = new Date(date);
    return new Intl.DateTimeFormat(lang).format(d);
  } catch (error) {
    return "";
  }
};
